import { MessageMedium, MessageMediumRenderer } from '@/components/Communication/types';
import WhatsAppRenderers from '@/components/Communication/renderers/WhatsApp';
import SMSRenderers from '@/components/Communication/renderers/SMS';
import EmailRenderers from '@/components/Communication/renderers/Email';

const rendererRegistry: Record<MessageMedium, MessageMediumRenderer> = {
  whatsapp: WhatsAppRenderers,
  sms: SMSRenderers,
  email: EmailRenderers,
};

export const getMessageRenderer = (medium: MessageMedium): MessageMediumRenderer => {
  return rendererRegistry[medium];
};
